import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Modal from '@dbk/ui-modal';
import { View, StyleSheet } from 'react-native';
import { FormGroup, TextInput, Message, Label, TextArea } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import FileUpload from '../../common/file-upload';
import convertToBase64 from '../../../../../src/utils/convert-to-base64';
import { DOC_UPLOAD } from '../../../../constants';
import { isEmpty } from 'lodash';
import Text from '@dbk/ui-text'
class DocUploadForm extends PureComponent {

  state = {

    formDataObj: {
      dwoDocName: '',
      docType: '',
      mgmtOrderMsg: '',
      remarks: '',
      clientMsg: '',
      base64DataArray:''
    }
  }

  componentWillMount(){
    if(this.props.docupload && this.props.docupload.uploadFormData){
      const data = this.props.docupload.uploadFormData;
      if(!isEmpty(data)){
        this.setState({
          formDataObj:data.formDataObj,
          browseFileName:data.browseFileName
        })
      }
    }
  }

  onChangeClicked = (e) => {
    const { name, value } = e.target;
    let attachedFileName = document.getElementById('browseFile').files[0];
    if (attachedFileName) {
      attachedFileName = attachedFileName.name;
    }
    this.setState(prevState => ({
      formDataObj: {
        ...prevState.formDataObj,
        [name]: name === "browseFileName" ? attachedFileName : value
      }
    }))
  }

  attachFile = async (file) => {
    await this.setState({
      browseFileName: file,
      isNoFile: false
    });
    
  }

  // toBase64 = (file) => new Promise((resolve, reject) => {
  //   const reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = () => resolve(reader.result);
  //   reader.onerror = error => reject(error);
  // });

  // async main() {
  //   console.log("XYZ helooo",await this.toBase64(this.state.browseFileName));
  // }

  async base64Convert(){
    const { app: { config: { uploadFileMaxSize, upload5MB, chunkSize } }, docupload: { setDocuploadLoading } } = this.props;
    setDocuploadLoading(true);
    let base64Data="";
    let dataArray="";

    if(this.state.browseFileName.size <= upload5MB){
       base64Data = await convertToBase64(this.state.browseFileName);
       setDocuploadLoading(false);
    }else{
      base64Data = await convertToBase64(this.state.browseFileName);
      setDocuploadLoading(false);
      const str = chunkSize || DOC_UPLOAD.UPLOAD_CHUNK_SIZE  ;
      //dataArray = base64Data.match(/[^]{1, + 'str'}/g);
      dataArray = base64Data.match(new RegExp('.{1,' + str + '}', 'g'));
    }
   
    if(base64Data){
      this.setState({
        base64Data, 
        base64DataArray: dataArray
      }, () => this.continueClicked())
    }
  }

  continueClicked() {
    const { docupload: { setUploadFormData, setDocUploadWizardIndex }} = this.props;
    setUploadFormData(this.state)
    setDocUploadWizardIndex(2);
  }

  validateBtn = () => {
    if (this.state.browseFileName && this.state.formDataObj.dwoDocName) {
      return false;
    }
    return true;
  }

  onBack(){
    this.props.docupload.setDocUploadWizardIndex(0);
  }


  render() {
    const { i18n: { messages }, docupload : { loading } } = this.props;

    return (
      <View className="columns small-12
                           medium-12 large-12
                           document-upload">

        <Modal
          testID="modal_docupload_form_test"
          disableOutsideClick={ true }
          isActive
          style={{ flex: '1' }}
          size="large"
          onClose={() => this.onBack()}
          header={messages['app.documentUpload.tab.uploadDocument']}
          content={
            <div className="document-upload">
              <View className="doc-upload-heading-text">
                <Text>{messages['app.documentUpload.headingText']}</Text>
              </View>
              <View className="uploadDocForm columns small-12
                           medium-12 large-10 large-centered">
                <div className="doc-upload-form-browseFile" style={{ marginBottom: '30px' }}>
                  <Label className="formLabel large-12 medium-12 small-12">{messages['app.documentUpload.browseFile']}</Label>
                  <FileUpload file={this.state.browseFileName}
                    onAttachFile={this.attachFile}
                    missingFile={this.state.isNoFile}
                    base64Data={this.state.base64Data} />
                </div>
                <FormGroup className="doc-upload-form-field-margin">
                  <Label className="formLabel">{messages['app.documentUpload.documentNametodisplayed']}</Label>
                  <View className='form__input-wrapper'>
                    <TextInput
                      testID="field_documentNametodisplayed_InputTextField_test"
                      accessibilityLabel="field_documentNametodisplayed_InputTextField_test"
                      name="dwoDocName"
                      size="large"
                      value={this.state.formDataObj.dwoDocName}
                      placeholder={messages['app.documentUpload.placeholder.documentNametodisplayed']}
                      onChange={this.onChangeClicked}
                      autoCorrect={false}
                      zIndex={-1}
                      autoCapitalize='none'
                      selectTextOnFocus={false}
                      caretHidden={false}
                      contextMenuHidden={false}
                      className="doc-upload-text-input"
                    />
                  </View>
                </FormGroup>
                <FormGroup className="doc-upload-form-field-margin">
                  <Label className="formLabel">{messages['app.documentUpload.contactManagementOrder']}</Label>
                  <View>
                    <TextInput
                      testID="field_contactManagementOrder_InputTextField_test"
                      accessibilityLabel="field_contactManagementOrder_InputTextField_test"
                      name="mgmtOrderMsg"
                      size="large"
                      value={this.state.formDataObj.mgmtOrderMsg}
                      placeholder={messages['app.documentUpload.placeholder.contactManagementOrder']}
                      onChange={this.onChangeClicked}
                      autoCorrect={false}
                      zIndex={-1}
                      autoCapitalize='none'
                      selectTextOnFocus={false}
                      caretHidden={false}
                      contextMenuHidden={false}
                      className="doc-upload-text-input"
                    />
                  </View>
                </FormGroup >
                <FormGroup className="doc-upload-form-field-margin">
                  <Label className="formLabel">{messages['app.documentUpload.remarks']}</Label>
                  <View className='form__input-wrapper'>
                    <TextArea
                      testID="field_remarks_InputTextField_test"
                      accessibilityLabel="field_remarks_InputTextField_test"
                      className="doc-upload-fixed-textArea"
                      name="remarks"
                      value={this.state.formDataObj.remarks}
                      placeholder={messages['app.documentUpload.placeholder.remarks']}
                      onChange={this.onChangeClicked}
                      autoCorrect={false}
                      zIndex={-1}
                      autoCapitalize='none'
                      keyboardType="remarks"
                      selectTextOnFocus={false}
                      caretHidden={false}
                      contextMenuHidden={false}
                    />
                  </View>
                </FormGroup>
                <FormGroup className="doc-upload-form-field-margin">
                  <Label className="formLabel">{messages['app.documentUpload.messageToClient']}</Label>
                  <View className='form__input-wrapper'>
                    <TextArea
                      testID="field_messageToClient_InputTextField_test"
                      accessibilityLabel="field_messageToClient_InputTextField_test"
                      className="doc-upload-fixed-textArea"
                      name="clientMsg"
                      value={this.state.formDataObj.clientMsg}
                      placeholder={messages['app.documentUpload.placeholder.messageToClient']}
                      onChange={this.onChangeClicked}
                      autoCorrect={false}
                      zIndex={-1}
                      maxlength={DOC_UPLOAD.TEXTAREA_MAXLENGTH}
                      autoCapitalize='none'
                      keyboardType="msgToClient"
                      selectTextOnFocus={false}
                      caretHidden={false}
                      contextMenuHidden={false}
                    />
                  </View>
                </FormGroup>
              </View>
              <View className="columns large-12 small-12 medium-12" >
                <View className="columns large-offset-6 large-6 small-12 medium-12 doc-upload-form-button">
                  <Button
                    className="columns large-6 small-12 medium-12 margin-left-1"
                    size='large'
                    onPress={() => this.onBack()} tertiary>
                    {messages['app.documentUpload.button.back']}
                  </Button>

                  <Button
                    className="columns large-6 small-12 medium-12 margin-left-1"
                    size='large'
                    loading={loading}
                    disabled={this.validateBtn() || loading }
                    onPress={() => this.base64Convert()} >
                    {messages['app.documentUpload.button.continue']}
                  </Button>
                </View>

              </View>
            </div>
          } />

      </View>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    rsaChangePage: { $call: 'rsa.changePage' },
    i18n: {
      messages: true,
    },
    app: {
      config: {
        uploadFileMaxSize: true,
        upload5MB: true,
        chunkSize: true
      },
    },
    docupload: {
      fetchContractsForBp: { $call: 'fetchContractsForBp' },
      contractDetails: true,
      search: { showSpinner: true },
      setDocUploadWizardIndex: { $set: 'docUploadWizardIndex' },
      uploadDocument: { $call: 'uploadDocument'},
      selectedContractDetails: true,
      docTypes: true,
      setUploadFormData: { $set: 'uploadFormData'},
      uploadFormData: true,
      loading: true,
      setDocuploadLoading: { $set: 'loading' }
    },
  }
})(DocUploadForm)
